class FloatingActionButtonsController {
  constructor(floatingActionButtonsService, $translate) {
    'ngInject';
    this.translate = $translate;
    this.floatingActionButtonsService = floatingActionButtonsService;
  }

  $postLink() {
    this.floatingActionButtonsService.run();
    if(this.switchColors) {
      this.switchColorButtons();
    }
  }

  $onInit() {
    this.isSingleAction = this.buttons.length === 1;
    this.literalFirstButton = this.getLiteralFirstButton();
    this.$onChanges = function() {
      this.literalFirstButton = this.getLiteralFirstButton();
    };
  } 

  getLiteralFirstButton() {
    if(this.isSimulate){
      return this.buttons[0].simulate;
    }
    if(this.isChoicesOpen ){
      return this.buttons[0].literalWithChoices;
    }
    return this.buttons[0].literal;
  }

  getClass() {
    return {
      'one-button': this.isSingleAction,
      'two-buttons': !this.isSingleAction
    };
  }

  switchColorButtons() {
    $('#firstFloatingButton').removeClass('btn-primary');
    $('#firstFloatingButton').addClass('btn-default');

    $('#secondFloatingButton').removeClass('btn-default');
    $('#secondFloatingButton').addClass('btn-primary');
  }
}

export default FloatingActionButtonsController;



// WEBPACK FOOTER //
// ./client/app/components/floatingActionButtons/floatingActionButtons.controller.js